<template>
  <div>
    <Prefecture :prefecture_id="prefecture_id" v-if="prefecture_id" />
    <Master v-else />
  </div>
</template>

<script>
import Prefecture from "./dashcomponents/prefectures";
import Master from "./dashcomponents/master";
export default {
  components: {
    Prefecture,
    Master,
  },
  data: () => ({
    prefecture_id: null,
  }),
  beforeCreate() {
    if (!localStorage.getItem("token")) {
      this.$router.push("/login");
    }
  },
  created() {
    if (this.$store.getters.getUserData.table_key == "prefectures") {
      this.prefecture_id = this.$store.getters.getUserData.table_id;
    } else if (this.$store.getters.getUserData.table_key == "attendants") {
      this.$router.push("/supplies-manager/attendants");
    } else if (this.$store.getters.getUserData.table_key == "providers") {
      this.$router.push("/supplies-manager/providers");
    }
  },
};
</script>

<style>
.fslt {
  color: whitesmoke;
  text-transform: uppercase;
}
.fsl {
  font-size: 2rem;
  color: whitesmoke;
  font-weight: 400;
}
</style>